<template>
  <div class="RegisterSuccess">
    <form @submit.prevent="registerForm">
      <h2>Thank you for registering</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      <button type="button" class="w-auto" @click="gotoSite()">Sign in</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "Register",
  components: {

  },
  data: () => ({

  }),
  methods: {
    gotoSite(){
      location.reload();
    },
  },
  created() {

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Auth/RegisterSuccess";
</style>
